import { useSelector, useDispatch } from 'react-redux'

import Snackbar from '@mui/material/Snackbar'

import { setToast, selectToastSetting } from 'store/toast/toastSlice'

const GlobalToastWrapper = ({ children }) => {
  const { toast } = useSelector(selectToastSetting)

  const dispatch = useDispatch()

  return (
    <>
      <Snackbar
        open={toast?.open}
        autoHideDuration={6000}
        anchorOrigin={{ vertical: 'top', horizontal: 'center' }}
        message={toast?.message}
        onClose={() => dispatch(setToast({ open: false, message: '' }))}
      />
      {children}
    </>
  )
}

export default GlobalToastWrapper
